import * as React from 'react'
import ReactSelect from 'react-select'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import { CheckBox, InputText } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'

const FIELDS = {
  username: 'username',
  bio: 'bio',
  email: 'email',
  password: 'password',
  email_notification: 'email_notification',
  admin: 'admin',
  comment: 'comment',
  fullname: 'fullname',
  fullname_furi: 'fullname_furi',
  post_code: 'post_code',
  address: 'address',
  tel: 'tel',
  sub_email: 'sub_email',
}
const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    border: `1px solid ${constants.COLORS.divider}`,
    borderRadius: 4,
    '&:hover': { border: `1px solid ${constants.COLORS.primary}` },
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: constants.COLORS.primary,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('user', { scope: 'activerecord.models' }),
})

const AdminUserIndex: React.FC<{ agents: any }> = props => {
  const { data: agents } = adminService.getDataFromJson(props.agents)
  const [agentIds, setAgentIds] = React.useState([])
  const [selectedUserType, setSelectedUserType] = React.useState(null)
  const [isAdmin, setIsAdmin] = React.useState<boolean>(false)
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const param = values
      if (!isAdmin && selectedUserType !== null) {
        param.user_type = selectedUserType?.value
      }
      param.agent_ids = agentIds
      await adminService.createUser(param)
      // TODO 遷移先でのFlush
      location.href = '/admin/users'
    },
    [isAdmin, selectedUserType, agentIds]
  )

  return (
    <AdminLayoutNew
      model="user"
      title={title}
      fields={FIELDS}
      indexLink="/admin/users"
      formItems={
        <>
          <InputText
            required={true}
            name="username"
            label={I18n.t('generic.nickname')}
            defaultValue=""
          />
          <InputText required={true} name="bio" defaultValue="" label={I18n.t('generic.bio')} />
          <InputText required={true} name="email" defaultValue="" label={I18n.t('generic.email')} />
          <InputText
            required={true}
            name="password"
            defaultValue=""
            label={I18n.t('generic.password')}
          />
          <S.CheckBoxWrapper>
            <CheckBox
              name="email_notification"
              defaultChecked={false}
              label={I18n.t('settings.email_notification')}
            />
          </S.CheckBoxWrapper>
          <InputText
            required={true}
            name="fullname"
            label={I18n.t('generic.fullname')}
            defaultValue=""
          />
          <InputText
            required={false}
            name="fullname_furi"
            label={I18n.t('generic.fullname_furi')}
            defaultValue=""
          />
          <InputText required={false} name="tel" label={I18n.t('generic.tel')} defaultValue="" />
          <InputText
            required={false}
            name="post_code"
            label={I18n.t('generic.post_code')}
            defaultValue=""
          />
          <InputText
            required={false}
            name="address"
            label={I18n.t('generic.address')}
            defaultValue=""
          />
          <InputText
            required={false}
            name="sub_email"
            label={I18n.t('generic.sub_email')}
            defaultValue=""
          />
          <InputText
            required={false}
            name="comment"
            label={I18n.t('generic.comment')}
            defaultValue=""
          />
          <CheckBox
            name="admin"
            defaultChecked={false}
            label="Admin"
            onChangeHandler={e => {
              setIsAdmin(e.target.checked)
            }}
          />
          {!isAdmin && (
            <S.ReactSelectWrapper>
              <p className="ReactSelect_Title">UserType</p>
              <div className="ReactSelect_Main">
                <ReactSelect
                  placeholder="Select User Type"
                  options={constants.USER_TYPES.filter(value => value.key !== 'admin').map(
                    value => ({
                      value: value.key,
                      label: value.label,
                    })
                  )}
                  isMulti={false}
                  onChange={setSelectedUserType}
                  styles={selectCustomStyles}
                  defaultValue={selectedUserType}
                  menuPortalTarget={document.querySelector('body')}
                />
              </div>
            </S.ReactSelectWrapper>
          )}
          {selectedUserType?.value === 'guide' && (
            <S.ReactSelectWrapper>
              <p className="ReactSelect_Title">{I18n.t('generic.agent_relations')}</p>
              <div className="ReactSelect_Main">
                <ReactSelect
                  placeholder={I18n.t('generic.agent_relations')}
                  options={agents.map(agent => ({
                    value: String(agent.id),
                    label: agent.username,
                  }))}
                  isMulti={true}
                  onChange={items => setAgentIds(items?.map(item => Number(item.value)) || [])}
                  styles={selectCustomStyles}
                  defaultValue={[]}
                  menuPortalTarget={document.querySelector('body')}
                />
              </div>
            </S.ReactSelectWrapper>
          )}
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

const S: { [key: string]: AnyStyledComponent } = {}
S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 240px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`
S.CheckBoxWrapper = styled.div`
  margin: 24px 0;
`
export default AdminUserIndex
